export enum Representant {
  INNER = 'INNER',
  OUTER = 'OUTER'
}
